import React from "react";

export default function WriterGuidelinesBanner() {
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 pb-10">
      <div className="bg-[#F4F1FC] rounded-3xl p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="text-center sm:text-left">
          <h3 className="text-lg sm:text-xl font-extrabold text-slate-900 mb-2">
            Follow our Writer Guidelines
          </h3>
          <p className="text-sm text-slate-500 mb-5 max-w-md">
            Make sure your blogs follow our content policy for a better
            reach
          </p>
          <a
            href="/dashboard/writer-guidelines"
            className="inline-block bg-[#7209B7] text-white font-semibold text-sm px-7 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200"
          >
            View Guidelines
          </a>
        </div>

        <div className="w-32 h-32 sm:w-40 sm:h-40 shrink-0">
          <img
            src="/img/dashboard/writer-guidelines.svg"
            alt="Writer guidelines"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </section>
  );
}
